import { IconName } from '@/config/icons'

export interface NavigationItem {
  label: string
  href: string
  icon: IconName
}

export const navigationItems: NavigationItem[] = [
  { label: 'Products', href: '/products', icon: 'cart' },
  { label: 'Services', href: '/services', icon: 'file-text' },
  { label: 'Wraps', href: '/car-wraps-edmonton', icon: 'car' },
  { label: 'Fleet', href: '/fleet-wraps', icon: 'fleet-wrap' },
  { label: 'Colours', href: '/colours', icon: 'palette' },
  { label: 'Gallery', href: '/gallery', icon: 'image' },
  { label: 'Articles', href: '/articles', icon: 'file-text' },
  { label: 'Contact', href: '/contact', icon: 'mail' },
  { label: 'Home', href: '/', icon: 'home' }
]

export const dashboardItems: NavigationItem[] = [
  { label: 'Dashboard', href: '/dashboard', icon: 'dashboard' },
  { label: 'Deployments', href: '/deployments', icon: 'rocket' },
  { label: 'Team', href: '/team', icon: 'users' },
  { label: 'Settings', href: '/settings', icon: 'settings' }
]

export const footerItems: NavigationItem[] = [
  { label: 'Privacy Policy', href: '/privacy-policy', icon: 'file-text' },
  { label: 'Terms of Service', href: '/terms-of-service', icon: 'file-text' },
  { label: 'Contact Us', href: '/contact', icon: 'mail' },
  { label: 'About', href: '/about', icon: 'file-text' },
  { label: 'Articles', href: '/articles', icon: 'file-text' },
  { label: 'Gallery', href: '/gallery', icon: 'image' },
  { label: 'Home', href: '/', icon: 'home' }
]
